import { render, staticRenderFns } from "./retailers.vue?vue&type=template&id=6fd8e488&scoped=true"
import script from "./retailers.vue?vue&type=script&lang=js"
export * from "./retailers.vue?vue&type=script&lang=js"
import style0 from "./retailers.vue?vue&type=style&index=0&id=6fd8e488&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd8e488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd8e488')) {
      api.createRecord('6fd8e488', component.options)
    } else {
      api.reload('6fd8e488', component.options)
    }
    module.hot.accept("./retailers.vue?vue&type=template&id=6fd8e488&scoped=true", function () {
      api.rerender('6fd8e488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/retailers.vue"
export default component.exports